/* eslint-disable camelcase */
/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import AssessmentPanel from './AssessmentPanel';
import ORSAssessmentReport from './ORSAssessmentReport';
import SRSAssessmentReport from './SRSAssessmentReport';

function Assessments({ intl, assessments }) {
  const { current_ors, previous_ors, has_previous_appointment, srs } =
    assessments;

  return (
    <div>
      <h1 style={{ fontSize: '20px' }}>
        {intl.formatMessage({ defaultMessage: 'Assessments' })}
      </h1>
      <hr
        style={{
          borderTop: '2px solid #c2adff',
          width: '25px',
          marginLeft: 0,
          marginTop: '10px',
        }}
      />
      <AssessmentPanel
        title={intl.formatMessage({
          defaultMessage: 'ORS Assessment Report',
        })}
        description={intl.formatMessage({
          defaultMessage: 'Shows the two most recent assessment results',
        })}
        defaultOpen={false}
      >
        <ORSAssessmentReport
          current_ors={current_ors}
          previous_ors={previous_ors}
          has_previous_appointment={has_previous_appointment}
        />
      </AssessmentPanel>
      <AssessmentPanel
        title={intl.formatMessage({
          defaultMessage: 'SRS Assessment Report',
        })}
        description={intl.formatMessage({
          defaultMessage: 'Shows the results from your last session',
        })}
        defaultOpen={false}
      >
        <SRSAssessmentReport
          srs={srs}
          hasPreviousAppointment={has_previous_appointment}
        />
      </AssessmentPanel>
    </div>
  );
}

Assessments.propTypes = {
  intl: PropTypes.object.isRequired,
  assessments: PropTypes.object.isRequired,
};

export default injectIntl(Assessments);
